import Link from 'next/link';

import { Trans } from '@kit/ui/trans';

export function TermsAndConditionsFormField() {
  return (
    <p className={'text-muted-foreground text-center text-xs'}>
      <Trans
        i18nKey={'auth:byCreatingAccountAgreeToTerms'}
        components={{
          TermsOfServiceLink: (
            <Link
              target={'_blank'}
              className={'underline'}
              href={'/terms-of-service'}
            >
              <Trans i18nKey={'auth:termsOfService'} />
            </Link>
          ),
          PrivacyPolicyLink: (
            <Link
              target={'_blank'}
              className={'underline'}
              href={'/privacy-policy'}
            >
              <Trans i18nKey={'auth:privacyPolicy'} />
            </Link>
          ),
        }}
      />
    </p>
  );
}
